import { gql } from "@apollo/client";

export const GET_DEVICE_STATES = gql`
  query deviceStates($deviceEsn: [String!]!) {
    deviceStates(deviceEsn: $deviceEsn) {
      deviceEsn
      connected
      lastActive
      status
      signalLevel
    }
  }
`;
